import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapEulaToSections } from 'utils/legal/sections';

const EULA = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapEulaToSections(t), [language]);
  const title = t('title', 'eula') || 'End User License Agreement';
  const lastUpdated = t('lastUpdated', 'eula') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default EULA;
